export const MarketInsightsIcon = () => (
    <img className='w-8 h-8' src={`${window.location.origin}/icons/28px_MarketInsights.svg`} alt="Market Insights" />
);
